import { Shadow, Text, Tooltip, VStack, HStack } from '@genial/components';
import { Color } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Box, Skeleton } from 'native-base';
import React from 'react';
import { Pressable } from 'react-native';

export declare namespace ChartItemTypes {
  export type Props = {
    isLoading?: boolean;
    color: keyof typeof Color;
    label: string;
    value: number;
    percentage: number;
    ignoreValue?: boolean;
    onPress?: () => void;
    isSelected?: boolean;
  };
}

export const ChartItem: React.FC<ChartItemTypes.Props> = React.memo(
  ({ isLoading, color, label, value, percentage, ignoreValue, isSelected, onPress }) => {
    const content = isLoading ? (
      <>
        <Skeleton borderRadius="full" width="inset.xs" height="inset.nano" />
        <Skeleton borderRadius="full" height="inset.nano" />
      </>
    ) : (
      <>
        <Box
          borderRadius="full"
          backgroundColor={Color[color]}
          width="inset.xs"
          height="inset.nano"
        />
        <VStack space="stack.nano">
          <HStack justifyContent={'space-between'} alignItems={'center'} flex={1}>
            <Tooltip label={label}>
              <Box flex={1}>
                <Text
                  color="brand.primary.darkest"
                  variant="regular"
                  fontSize="xs"
                  isTruncated
                  numberOfLines={1}>
                  {label}
                </Text>
              </Box>
            </Tooltip>
            <Text variant="regular" fontSize="xs" color="neutral.medium">
              {Utils.Mask.Percentage(percentage)}
            </Text>
          </HStack>
          <Text color="brand.primary.darkest" variant="regular" fontSize="xs">
            {ignoreValue ? Utils.Mask.Percentage(percentage) : Utils.Mask.Money(value)}
          </Text>
        </VStack>
      </>
    );

    return (
      <Box flexGrow={1} flexShrink={1} flexBasis="116px" opacity={isSelected ? 1 : 0.5}>
        <Shadow level={1} testId="shadow" borderRadius="sm" flex={1}>
          <Pressable onPress={onPress}>
            <VStack paddingY="inset.nano" paddingX="inset.xs" space="stack.nano">
              {content}
            </VStack>
          </Pressable>
        </Shadow>
      </Box>
    );
  }
);
